import { render, staticRenderFns } from "./schedule-table-body.vue?vue&type=template&id=7870cfc5"
import script from "./schedule-table-body.vue?vue&type=script&lang=js"
export * from "./schedule-table-body.vue?vue&type=script&lang=js"
import style0 from "./schedule-table-body.vue?vue&type=style&index=0&id=7870cfc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports